import { useServices } from '@/app/providers';
import { useAbility } from '@/modules/identity/application/ability';
import { canUseAdminLayoutV2 } from '@/shared/navigation/canUseAdminLayoutV2';
import type React from 'react';
import { AdminLayoutV2 } from './AdminLayoutV2';
import { MainLayout } from './MainLayout';

interface LayoutWrapperProps {
  children: React.ReactNode;
}

export const LayoutWrapper: React.FC<LayoutWrapperProps> = ({ children }) => {
  const ability = useAbility();
  const { currentUser } = useServices();

  if (canUseAdminLayoutV2(ability, currentUser?.tenantRole)) {
    return <AdminLayoutV2>{children}</AdminLayoutV2>;
  }

  return <MainLayout>{children}</MainLayout>;
};
